import AuthorizationWrapper from "../AuthorizationWrapper";
import { Grid, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import { _get } from "../../Api";
import SearchForms from "../Forms/SearchForms";

const isValid = (value) => {
  if (typeof value !== "string") {
    return false;
  }

  if (!(value.substr(0, 1) === "+" || value.substr(0, 1) === "-")) {
    return false;
  }

  if (value.length !== 5) {
    return false;
  }

  let hour = parseInt(value.substr(1, 2));
  let minutes = parseInt(value.substr(3, 2));

  if (hour < 0 || hour >= 12) {
    return false;
  }
  if (minutes < 0 || minutes >= 60) {
    return false;
  }
  return true;
};

function TimezoneSetting(props) {
  const [timezone, setTimezone] = React.useState(props.setting.value);

  const [timezones, setTimezones] = React.useState(null);

  useEffect(() => {
    _get("/nova/v2/merchant/datetimezones").then((res) => {
      setTimezones(res.data);
    });
  }, []);

  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <Grid container alignItems={"center"} spacing={1}>
            <Grid item xs={6}>
              {timezones && (
                <SearchForms
                  handleSelect={(selected) => {
                    setTimezone(selected);
                    props.onChange(selected);
                  }}
                  allResults={timezones}
                  valueVisibleAsLabel={true}
                  getValue={(entry) => entry}
                  value={timezone}
                />
              )}
            </Grid>
            <Grid item xs={6}>
              <Typography>{props.label}</Typography>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}

export default withIntl(TimezoneSetting);
